import { deleteMembership } from '@/store/module/membership/mutation/delete.js';
import { setMembership } from '@/store/module/membership/mutation/setMembership.js';
import { setMemberships } from '@/store/module/membership/mutation/setMemberships.js';

export const mutations = {
	delete: deleteMembership,
	setMembership,
	setMemberships
};
